// React
import React, { useState, useContext } from 'react';

// Styles
import styles from './Actions.module.scss';

// Third party
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';

// Services
import { deleteData as deleteDataType } from '../../../services/data-types';
import { deleteData as deleteTaxonomy } from '../../../services/taxonomies';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Material UI
import {
  Button,
  IconButton,
  Popover,
  Typography,
  List,
  ListItem,
  ClickAwayListener
} from '@material-ui/core';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';

// This component
export default function Actions({
  typeOfData,
  id,
  endpoint,
  deleteApiEndpoint,
  deleteApiPath,
  hash
}) {

  // Listing Context
  const { setRefreshDataGrid } = useContext(ListingContext);

  // Anchor
  const [anchorEl, setAnchorEl] = useState(null);

  // Handle click
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle close
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Visible or not (status)
  const open = Boolean(anchorEl);

  // Handle delete item
  const handleDelete = (event) => {
    event.preventDefault();

    let confirmDelete = window.confirm('Are you sure you want delete this record? This action cannot be undone.')

    if(confirmDelete) {

      let promise = null;

      if (typeOfData === 'data-type' || typeOfData === 'sales-channel') {
        promise = deleteDataType({
          endpoint: deleteApiEndpoint,
          itemId: deleteApiPath ? deleteApiPath : id,
        });
      } else {
        promise = deleteTaxonomy({
          endpoint: deleteApiEndpoint,
          identifier: hash ? hash : id,
        });
      }

      trackPromise(
        promise.then(
          (bool) => {
            handleClose();
            setRefreshDataGrid(bool);
          },
          // (error) => window.alert(error)
        )
      );
    }
    else {
      handleClose();
    }
  };

  // Handle clone item
  const handleClone = (event) => {
    event.preventDefault();
    window.alert(`TO-DO: clone ${hash ? hash : id} (waiting for backend/webservice)`);
    handleClose();
  };

  return (
    <div className={styles.wrapper}>
      <IconButton
        size="small"
        component={RouterLink}
        to={`${endpoint}/${hash ? hash : id}`}>
        <CreateOutlinedIcon color="secondary" fontSize="small" />
      </IconButton>

      {deleteApiEndpoint !== undefined &&
      <>
        <IconButton
          size="small"
          onClick={handleClick}
          id={`actions-${hash ? hash : id}`}>
          <MoreVertIcon color="secondary" fontSize="small" />
        </IconButton>

        <Popover
          classes={{ paper: styles.paper }}
          elevation={1}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}>
          <ClickAwayListener onClickAway={handleClose}>
            <List className={styles.list}>
              <ListItem className={styles.item}>
                <Button
                  className={styles.button}
                  onClick={handleDelete}
                  startIcon={
                    <DeleteOutlineOutlinedIcon
                      color="secondary"
                      fontSize="small"
                    />
                  }
                  id={`action-delete-${hash ? hash : id}`}>
                  <Typography>Delete</Typography>
                </Button>
              </ListItem>

              <ListItem className={styles.item}>
                <Button
                  disabled={true} // TO-DO: waiting for backend/webservice
                  className={styles.button}
                  onClick={handleClone}
                  startIcon={
                    <FileCopyOutlinedIcon
                      color="disabled" // color="secondary" // TO-DO: waiting for backend/webservice
                      fontSize="small"
                    />
                  }
                  id={`action-clone-${hash ? hash : id}`}>
                  <Typography>Clone</Typography>
                </Button>
              </ListItem>
            </List>
          </ClickAwayListener>
        </Popover>
      </>
      }

    </div>
  );
}

// Properties
Actions.propTypes = {
  typeOfData: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  endpoint: PropTypes.string.isRequired,
  deleteApiEndpoint: PropTypes.string,
  hash: PropTypes.string
};
